import * as constants from './constants';

export function setPublicationsList(publications) {
  return {
    type: constants.SET_PUBLICATION_LIST,
    publications,
  };
}

export function setPublicationsHistoryForActivity(historyList, activityId, outputType, market) {
  return {
    type: constants.SET_PUBLICATION_HISTORY,
    historyList,
    activityId,
    outputType,
    market,
  };
}

export function setPublicationsSort(sort) {
  return {
    type: constants.SET_PUBLICATIONS_SORT,
    sort,
  };
}

export function setPublicationsSearch(search) {
  return {
    type: constants.SET_PUBLICATIONS_SEARCH,
    search,
  };
}

export function updatePublicationsList(publication, updateType) {
  return {
    type: constants.UPDATE_PUBLICATION_LIST,
    publication,
    updateType,
  };
}

export function updatePublicationsStatus(publication) {
  return {
    type: constants.UPDATE_PUBLICATION_STATUS,
    publication,
  };
}

export function updatePublicationsDetail(publication) {
  return {
    type: constants.UPDATE_PUBLICATION_DETAIL,
    publication,
  };
}
